import type { ReactNode } from "react";
import { getTablerIcon } from "@/lib/tabler-icons";

interface IconProps {
  name?: string | null;
  size?: number;
  className?: string;
  fallback?: ReactNode;
}

export function Icon({ name, size = 20, className, fallback = "-", ...props }: IconProps) {
  if (!name) {
    return <span className="text-muted-foreground">{fallback}</span>;
  }

  const IconComponent = getTablerIcon(name);
  if (!IconComponent) {
    return <span className="text-muted-foreground">{name}</span>;
  }

  return <IconComponent size={size} className={className} {...props} />;
}
